import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as PaperEdit } from '../../assets/images/svg/paper-edit.svg';
import themeColors from '../../assets/styles/themeColors';

const PaperEditStyled = styled.div`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  border-radius: 100%;
  background-color: ${themeColors.colorBackgroundPrimaryDark};

  svg {
    circle {
      fill: ${({ cc }) => cc || themeColors.colorBackgroundPrimaryDark};
      stroke: ${({ cs }) => cs || 'none'};
    }

    path {
      stroke: ${({ sc }) => sc || themeColors.colorTextPrimary};
    }
  }
`;

const PaperEditIcon = (props) => (
  <PaperEditStyled {...props}>
    <PaperEdit />
  </PaperEditStyled>
);

PaperEditIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  circleColor: PropTypes.string,
  circleStroke: PropTypes.string,
  strokeColor: PropTypes.string,
};

PaperEditIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default PaperEditIcon;
